// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ekpx","index":"styles_index__3XXzv"};